import type { ReactNode } from 'react';

export function TaskBoard({ children }: { children: ReactNode }): JSX.Element {
  return <div className="av-task-board">{children}</div>;
}
